import React, { useEffect, useRef, useState } from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";

import PrimeReact from "primereact/api";

import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Tooltip } from "primereact/tooltip";

import { useHistory, useLocation } from "react-router-dom";
import { useToast } from "../../../../hooks/toast";
import { Container } from "../styles";
import api from "../../../../services/api";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import { useExportacao } from "../../../../hooks/exportacao";

interface IExportData {
  proc_reg: string;
  proc_data_ajuiz: string;
  proc_em_acordo: string;
  proc_desfecho_data: string;
  proc_autor: string;
  proc_reu: string;
  advogado_nome: string;
  proc_localizacao: string;
  acao_descricao: string;
  proc_assunto: string;
  proc_situacao: string;
  pedido_vl_provavel: string;
  pedido_vl_possivel1: string;
  pedido_vl_possivel2: string;
  calc_poss_remota: string;
  valor_causa: string;
  possib_texto: string;
  proc_id: number;
}

interface IFinancialItems {
  proc_id: number;
  proc_pedidos_possib_geral: number;
  proc_valor_causa: number;
}

interface IFinancialRequests {
  pedido_id: number | null;
  pedido_proc_id: number;
  pedido_descricao: string;
  pedido_possibilidade: number;
  pedido_vl_demandado: number;
  pedido_vl_provavel: number;
  pedido_vl_possivel: number;
  pedido_vl_possivel2: number;
  cod_indexador: number;
  data_inicio_monetario: Date;
  data_inicio_juros: Date;
  correcao_monetaria: string;
  juros_simples: string;
  id_descricao_pedido: number;
  val_juros_atualizado: number;
  val_calculo_indice: number;
  val_juros_provavel: number;
  val_juros_possivel: number;
  val_juros_possivel2: number;
  val_calculo_provavel: number;
  val_calculo_possivel: number;
  val_calculo_possivel2: number;
  data_pedido: Date;
  cod_indexador2: number;
  data_inicio_monetario2: Date;
  cod_indexador3: number;
  data_inicio_monetario3: Date;
  cod_indexador4: number;
  data_inicio_monetario4: Date;
  cod_indexador5: number;
  data_inicio_monetario5: Date;
  negativo: number;
  calc_poss_remota: number;
  calc_vl_cont: number;
  pedido_vl_demandado_original: number;
  pedido_vl_provavel_original: number;
  pedido_vl_possivel_original: number;
  pedido_vl_possivel2_original: number;
  id_pedido_descricao: number;
}

interface IFinancialCostDeposit {
  dep_cus_id: number | null;
  dep_cus_proc_id: number;
  dep_cus_data: Date;
  dep_cus_cod_natureza: number;
  dep_cus_valor: number;
  dep_cus_classificacao: number;
}

interface ICostDepositProperties {
  natureza_id: number | null;
  natureza_descricao: string;
}

interface IPawnedGoods {
  dep_cus_id: number | null;
  dep_cus_proc_id: number;
  dep_cus_data: Date;
  dep_cus_cod_natureza: number;
  dep_cus_valor: number;
  dep_cus_classificacao: number;
  bens_penh_id: number | null;
  bens_penh_proc_id: number;
  bens_penh_descricao: string;
  bens_penh_parte: number;
  bens_penh_data: Date;
  bens_penh_valor: number;
  bens_penh_depositario: string;
}

const LawsuitSummaryReportExcel: React.FC = () => {
  PrimeReact.ripple = true;

  const { exportando, exportar } = useExportacao();

  const [lawsuits, setLawsuits] = useState<IExportData[]>([]);
  const [exportData, setExportData] = useState<IExportData[]>([]);
  const [financialItems, setFinancialItems] = useState<IFinancialItems[]>([]);
  const [financialRequests, setFinancialRequests] = useState<
    IFinancialRequests[]
  >([]);
  const [financialCostDeposits, setFinancialCostDeposits] = useState<
    IFinancialCostDeposit[]
  >([]);
  const [costDeposits, setCostDeposits] = useState<ICostDepositProperties[]>(
    []
  );
  const [pawnedGoods, setPawnedGoods] = useState<IPawnedGoods[]>([]);

  const [loading, setLoading] = useState(true);

  // para tabela
  const [globalFilter, setGlobalFilter] = useState("");
  const dt = useRef(null);
  const { addToast } = useToast();
  const history = useHistory();
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const state = location.state as any;

  let status = "0";
  if (state) {
    status = state?.proc_em_acordo;
  }

  useEffect(() => {
    (async () => {
      await api
        .get("/lawsuits/financialcostdeposits/show/all")
        .then((response) => {
          setFinancialCostDeposits(response.data);
        });
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const response = await api.get("/lawsuits/costsdeposits/show/all");
      setCostDeposits(response.data);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      await api
        .get("/lawsuits/financialitems/pawnedgoods/show/all")
        .then((response) => {
          setPawnedGoods(response.data);
        });
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      await api
        .post("/reports/lawsuit/simplified/excel", state)
        .then((response) => {
          setLawsuits(response.data);
        });
      setLoading(false);
    })();
  }, [state]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      await api.get("/lawsuits/financialitems/show/all").then((response) => {
        setFinancialItems(response.data);
      });
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      await api
        .get("/lawsuits/financialrequests/filterallrequests")
        .then((response) => {
          setFinancialRequests(response.data);
        });
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const lawsuitExportData: IExportData[] = [];
        lawsuits.forEach((lawsuit) => {
          let pedido_vl_provavel = 0.0;
          let pedido_vl_possivel = 0.0;
          let pedido_vl_possivel2 = 0.0;
          let calc_poss_remota = 0.0;
          let possib_texto = "";
          let proc_valor_causa = "0";

          const filteredGainLoss = financialItems.filter(
            (item) => item.proc_id === lawsuit.proc_id,
            []
          );
          const possibility = filteredGainLoss[0]?.proc_pedidos_possib_geral
            ? filteredGainLoss[0]?.proc_pedidos_possib_geral
            : 0;
          switch (possibility) {
            case 1:
              possib_texto = "Êxito";
              break;
            case 2:
              possib_texto = "Perda";
              break;
            default:
              possib_texto = "";
          }
          proc_valor_causa = filteredGainLoss[0].proc_valor_causa
            ? `${filteredGainLoss[0].proc_valor_causa}`
            : "0.00";

          const filteredFinancialRequests = financialRequests.filter(
            (item) => item.pedido_proc_id === lawsuit.proc_id,
            []
          );

          pedido_vl_provavel = filteredFinancialRequests
            .map((value) => Number(value.pedido_vl_provavel))
            .reduce((a, b) => a + b, 0);

          pedido_vl_possivel = filteredFinancialRequests
            .map((value) => Number(value.pedido_vl_possivel))
            .reduce((a, b) => a + b, 0);

          pedido_vl_possivel2 = filteredFinancialRequests
            .map((value) => Number(value.pedido_vl_possivel2))
            .reduce((a, b) => a + b, 0);

          calc_poss_remota = filteredFinancialRequests
            .map((value) => Number(value.calc_poss_remota))
            .reduce((a, b) => a + b, 0);

          const formattedLawsuitValue = Number(proc_valor_causa).toLocaleString(
            "pt-BR",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          );
          const formattedProbable = Number(pedido_vl_provavel).toLocaleString(
            "pt-BR",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          );
          const formattedPossible1 = Number(pedido_vl_possivel).toLocaleString(
            "pt-BR",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          );

          const formattedPossible2 = Number(pedido_vl_possivel2).toLocaleString(
            "pt-BR",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          );

          const formattedRemoteCalc = Number(calc_poss_remota).toLocaleString(
            "pt-BR",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          );

          lawsuitExportData.push({
            proc_id: lawsuit.proc_id,
            proc_reg: lawsuit.proc_reg,
            proc_data_ajuiz: lawsuit.proc_data_ajuiz,
            proc_em_acordo: lawsuit.proc_em_acordo,
            proc_desfecho_data: lawsuit.proc_desfecho_data,
            proc_autor: lawsuit.proc_autor,
            proc_reu: lawsuit.proc_reu,
            advogado_nome: lawsuit.advogado_nome,
            proc_localizacao: lawsuit.proc_localizacao,
            acao_descricao: lawsuit.acao_descricao,
            proc_assunto: lawsuit.proc_assunto,
            proc_situacao: lawsuit.proc_situacao,
            pedido_vl_provavel: formattedProbable,
            pedido_vl_possivel1: formattedPossible1,
            pedido_vl_possivel2: formattedPossible2,
            calc_poss_remota: formattedRemoteCalc,
            possib_texto,
            valor_causa: formattedLawsuitValue,
          });
        });

        setExportData(lawsuitExportData);
      } catch (e) {
        if (typeof e === "string") {
          e.toUpperCase();
        } else if (e instanceof Error) {
          e.message;
        }
      }
    };

    setLoading(true);
    fetchData();
    setLoading(false);
  }, [addToast, financialItems, financialRequests, lawsuits, location.state]);

  // Helper para achar a descrição da natureza:
  const filterNatureByCostId = (cod: number) => {
    const found = costDeposits.find((n) => n.natureza_id === cod);
    return found?.natureza_descricao ?? "-";
  };

  const formatBRL = (n: number | string | undefined) =>
    Number(n ?? 0).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const formatDateBR = (d: Date | string | null | undefined) => {
    if (!d) return "-";
    const data = new Date(d);
    return Number.isNaN(data.getTime())
      ? "-"
      : data.toLocaleDateString("pt-BR", { timeZone: "UTC" });
  };

  // ===== Helpers de “mini-tabela” dentro da célula =====
  type FeeRow = { date: string; nature: string; value: string };
  type DepositRow = FeeRow;
  type GoodRow = {
    date: string;
    desc: string;
    part: string;
    value: string;
    depositary: string;
  };

  const feeRows = (procId: number): FeeRow[] =>
    financialCostDeposits
      .filter(
        (c) => c.dep_cus_proc_id === procId && c.dep_cus_classificacao === 1
      )
      .sort(
        (a, b) =>
          new Date(a.dep_cus_data).getTime() -
          new Date(b.dep_cus_data).getTime()
      )
      .map((c) => ({
        date: formatDateBR(c.dep_cus_data),
        nature: filterNatureByCostId(Number(c.dep_cus_cod_natureza)),
        value: Number(c.dep_cus_valor ?? 0).toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      }));

  const depositRows = (procId: number): DepositRow[] =>
    financialCostDeposits
      .filter(
        (c) => c.dep_cus_proc_id === procId && c.dep_cus_classificacao === 2
      )
      .sort(
        (a, b) =>
          new Date(a.dep_cus_data).getTime() -
          new Date(b.dep_cus_data).getTime()
      )
      .map((c) => ({
        date: formatDateBR(c.dep_cus_data),
        nature: filterNatureByCostId(Number(c.dep_cus_cod_natureza)),
        value: Number(c.dep_cus_valor ?? 0).toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      }));

  const goodsRows = (procId: number): GoodRow[] =>
    pawnedGoods
      .filter((p) => p.bens_penh_proc_id === procId)
      .sort(
        (a, b) =>
          new Date(a.bens_penh_data).getTime() -
          new Date(b.bens_penh_data).getTime()
      )
      .map((p) => {
        const part = p.bens_penh_parte === 1 ? "Cliente" : "Parte adversa";
        const depositary = Number.isNaN(Number(p.bens_penh_depositario))
          ? p.bens_penh_depositario
          : `R$ ${formatBRL(p.bens_penh_depositario as unknown as number)}`;
        return {
          date: formatDateBR(p.bens_penh_data),
          desc: p.bens_penh_descricao,
          part,
          value: Number(p.bens_penh_valor ?? 0).toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
          depositary,
        };
      });

  // estilos inline p/ as mini-tabelas
  const miniTableStyle: React.CSSProperties = {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: 12,
  };
  const thStyle: React.CSSProperties = {
    textAlign: "left",
    padding: "2px 6px",
    borderBottom: "1px solid #e9ecef",
    whiteSpace: "nowrap",
  };
  const tdStyle: React.CSSProperties = {
    padding: "2px 6px",
    verticalAlign: "top",
  };

  // Monta o bloco único por processo com os 3 grupos
  // Helpers para pegar arrays por processo
  const getFees = (procId: number) =>
    financialCostDeposits
      .filter(
        (c) => c.dep_cus_proc_id === procId && c.dep_cus_classificacao === 1
      )
      .sort(
        (a, b) =>
          new Date(a.dep_cus_data).getTime() -
          new Date(b.dep_cus_data).getTime()
      )
      .map(
        (c) =>
          `${formatDateBR(c.dep_cus_data)} — ${filterNatureByCostId(
            Number(c.dep_cus_cod_natureza)
          )} — R$ ${formatBRL(c.dep_cus_valor)}`
      );

  const getDeposits = (procId: number) =>
    financialCostDeposits
      .filter(
        (c) => c.dep_cus_proc_id === procId && c.dep_cus_classificacao === 2
      )
      .sort(
        (a, b) =>
          new Date(a.dep_cus_data).getTime() -
          new Date(b.dep_cus_data).getTime()
      )
      .map(
        (c) =>
          `${formatDateBR(c.dep_cus_data)} — ${filterNatureByCostId(
            Number(c.dep_cus_cod_natureza)
          )} — R$ ${formatBRL(c.dep_cus_valor)}`
      );

  const getGoods = (procId: number) =>
    pawnedGoods
      .filter((p) => p.bens_penh_proc_id === procId)
      .sort(
        (a, b) =>
          new Date(a.bens_penh_data).getTime() -
          new Date(b.bens_penh_data).getTime()
      )
      .map((p) => {
        const parte = p.bens_penh_parte === 1 ? "Cliente" : "Parte adversa";
        const dep = Number.isNaN(Number(p.bens_penh_depositario))
          ? p.bens_penh_depositario
          : `R$ ${formatBRL(p.bens_penh_depositario as unknown as number)}`;
        return `${formatDateBR(p.bens_penh_data)} — ${
          p.bens_penh_descricao
        } — ${parte} — R$ ${formatBRL(
          p.bens_penh_valor
        )} — Depositário: ${dep}`;
      });

  const exportExcel = () => {
    import("excel4node").then((xlsx) => {
      const workbook = new xlsx.Workbook();
      const ws = workbook.addWorksheet("Horas");

      // Estilos
      const wrapTop = workbook.createStyle({
        alignment: { wrapText: true, vertical: "top" },
      });
      const headerStyle = workbook.createStyle({ font: { bold: true } });

      // Cabeçalho do relatório
      ws.cell(1, 1).string("Pabst & Hadlich Advogados Associados");
      ws.cell(2, 1).string("Relatório Resumido de Informações Processuais");

      // HEADERS
      let headers: string[] =
        Number(status) === 0
          ? [
              "Número do processo",
              "Data de Ajuizamento",
              "Pólo ativo",
              "Pólo passivo",
              "Adv. Responsável",
              "Localização",
              "Natureza",
              "Objeto",
              "Posição atual",
              "Provável (≥80%)",
              "Possível (>50%)",
              "Possível (≤50%)",
              "Remota (≤20%)",
              "Probabilidade",
              "Valor nominal do processo",
            ]
          : [
              "Número do processo",
              "Data de Ajuizamento",
              "Situação",
              "Data desfecho",
              "Pólo ativo",
              "Pólo passivo",
              "Adv. Responsável",
              "Localização",
              "Natureza",
              "Objeto",
              "Posição atual",
              "Provável (≥80%)",
              "Possível (>50%)",
              "Possível (≤50%)",
              "Remota (≤20%)",
              "Probabilidade",
              "Valor nominal do processo",
            ];

      // Adiciona as 3 colunas novas
      headers = [
        ...headers,
        "Custas Processuais",
        "Depósitos Judiciais",
        "Bens Penhorados",
      ];

      // escreve headers na linha 4
      headers.forEach((h, i) =>
        ws
          .cell(4, i + 1)
          .string(h)
          .style(headerStyle)
      );

      // larguras (ajuste fino conforme necessário)
      headers.forEach((_, i) => ws.column(i + 1).setWidth(24));
      // as três colunas de detalhes geralmente precisam ser mais largas:
      ws.column(headers.length - 2).setWidth(40);
      ws.column(headers.length - 1).setWidth(40);
      ws.column(headers.length).setWidth(60);

      // Posição das colunas dos 3 grupos
      const COL_FEES = headers.length - 2; // Custas
      const COL_DEPOSITS = headers.length - 1; // Depósitos
      const COL_GOODS = headers.length; // Bens

      // Mapeia quais colunas são "fixas" do processo (para fazer merge)
      // -> índices 1-based até antes das 3 novas colunas
      const FIXED_COLS = Array.from(
        { length: headers.length - 3 },
        (_, i) => i + 1
      );

      let row = 5; // começa a escrever aqui

      // Para cada processo do exportData
      exportData.forEach((item) => {
        // arrays dos 3 grupos
        const fees = getFees(item.proc_id);
        const deposits = getDeposits(item.proc_id);
        const goods = getGoods(item.proc_id);

        const maxLen = Math.max(fees.length, deposits.length, goods.length, 1); // pelo menos 1

        const baseCells =
          Number(status) === 0
            ? [
                item.proc_reg,
                item.proc_data_ajuiz,
                item.proc_autor,
                item.proc_reu,
                item.advogado_nome,
                item.proc_localizacao,
                item.acao_descricao,
                item.proc_assunto,
                item.proc_situacao,
                item.pedido_vl_provavel,
                item.pedido_vl_possivel1,
                item.pedido_vl_possivel2,
                item.calc_poss_remota,
                item.possib_texto,
                item.valor_causa,
              ]
            : [
                item.proc_reg,
                item.proc_data_ajuiz,
                item.proc_desfecho_data && item.proc_desfecho_data.length > 0
                  ? "Arquivado"
                  : "Ativo",
                item.proc_desfecho_data ?? "",
                item.proc_autor,
                item.proc_reu,
                item.advogado_nome,
                item.proc_localizacao,
                item.acao_descricao,
                item.proc_assunto,
                item.proc_situacao,
                item.pedido_vl_provavel,
                item.pedido_vl_possivel1,
                item.pedido_vl_possivel2,
                item.calc_poss_remota,
                item.possib_texto,
                item.valor_causa,
              ];

        const BASE_COL_COUNT = baseCells.length;

        // Escreve o bloco de linhas do processo
        for (let i = 0; i < maxLen; i++) {
          const r = row + i;

          // Preenche as colunas dos 3 grupos sincronizadas pelo índice i
          const feeCell = fees[i] ?? "";
          const depCell = deposits[i] ?? "";
          const goodCell = goods[i] ?? "";

          // 1) Preenche as colunas fixas SOMENTE na primeira linha do bloco
          if (i === 0) {
            for (let c = 0; c < BASE_COL_COUNT; c++) {
              ws.cell(r, c + 1).string(String(baseCells[c] ?? ""));
            }
          }

          // 2) Preenche as 3 colunas dos grupos
          ws.cell(r, COL_FEES).string(feeCell).style(wrapTop);
          ws.cell(r, COL_DEPOSITS).string(depCell).style(wrapTop);
          ws.cell(r, COL_GOODS).string(goodCell).style(wrapTop);
        }

        // 3) Faz MERGE vertical das colunas fixas para cobrir todo o bloco do processo
        if (maxLen > 1) {
          FIXED_COLS.forEach((colIndex) => {
            // evita mesclar as 3 colunas novas
            if (colIndex <= BASE_COL_COUNT) {
              ws.cell(row, colIndex, row + maxLen - 1, colIndex, true);
            }
          });
        }

        // avança a "row" para o próximo processo
        row += maxLen;
      });

      const filename = "Relatorio-resumido-informacoes-processuais";
      workbook.writeToBuffer().then((buffer: BlobPart) => {
        import("file-saver").then((module) => {
          if (module && module.default) {
            const EXCEL_TYPE =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            const EXCEL_EXTENSION = ".xlsx";
            const data = new Blob([buffer], { type: EXCEL_TYPE });
            module.default.saveAs(
              data,
              `${filename}_export_${new Date().getTime()}${EXCEL_EXTENSION}`
            );
          }
        });
      });
    });
  };

  const searchLawsuitsSimplified = () => {
    history.push("/report/lawsuit/simplified/excel/search");
  };

  const header = (
    <div className="flex align-items-center export-buttons">
      <Button
        type="button"
        icon="pi pi-file-excel"
        onClick={() => exportar(exportExcel)}
        className="p-button-success mr-2"
        tooltip="Exportar para Excel"
        tooltipOptions={{ position: "right" }}
      />
      <Button
        icon="pi pi-search"
        className="p-button-secondary p-mr-2"
        type="button"
        onClick={searchLawsuitsSimplified}
        tooltip="Nova consulta de processos"
        tooltipOptions={{ position: "right" }}
      />
      <span className="p-input-icon-left p-ml-auto">
        <i className="pi pi-search" />
        <InputText
          type="search"
          value={globalFilter}
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder="Pesquisar na tabela"
        />
      </span>
    </div>
  );

  const statusBodyTemplate = (rowData: { proc_desfecho_data: string }) => {
    if (lawsuits !== undefined) {
      let statusText = "Ativo";
      if (rowData.proc_desfecho_data) {
        statusText = "Arquivado";
      }

      return statusText;
    }
    return "";
  };

  const paginatorLeft = (
    <Button type="button" icon="pi pi-refresh" className="p-button-text" />
  );
  const paginatorRight = (
    <Button type="button" icon="pi pi-cloud" className="p-button-text" />
  );

  // CUSTAS
  const feesBodyTemplate = (row: IExportData) => {
    const rows = feeRows(row.proc_id);
    return rows.length ? (
      <div style={{ maxHeight: 220, overflowY: "auto" }}>
        <table style={miniTableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Data</th>
              <th style={thStyle}>Natureza</th>
              <th style={{ ...thStyle, textAlign: "right" }}>Valor</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={`${r.date}-${r.nature}-${r.value}`}>
                <td
                  style={{
                    ...tdStyle,
                    whiteSpace: "nowrap",
                    textAlign: "left",
                  }}
                >
                  {r.date}
                </td>
                <td
                  style={{
                    ...tdStyle,
                    whiteSpace: "normal",
                    textAlign: "left",
                  }}
                >
                  {r.nature}
                </td>
                <td
                  style={{
                    ...tdStyle,
                    textAlign: "right",
                    whiteSpace: "nowrap",
                  }}
                >
                  R$
                  {r.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <span>—</span>
    );
  };

  // DEPÓSITOS
  const depositsBodyTemplate = (row: IExportData) => {
    const rows = depositRows(row.proc_id);
    return rows.length ? (
      <div style={{ maxHeight: 220, overflowY: "auto" }}>
        <table style={miniTableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Data</th>
              <th style={thStyle}>Natureza</th>
              <th style={{ ...thStyle, textAlign: "right" }}>Valor</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={`${r.date}-${r.nature}-${r.value}`}>
                <td
                  style={{
                    ...tdStyle,
                    whiteSpace: "nowrap",
                    textAlign: "left",
                  }}
                >
                  {r.date}
                </td>
                <td
                  style={{
                    ...tdStyle,
                    whiteSpace: "normal",
                    textAlign: "left",
                  }}
                >
                  {r.nature}
                </td>
                <td
                  style={{
                    ...tdStyle,
                    textAlign: "right",
                    whiteSpace: "nowrap",
                  }}
                >
                  R$
                  {r.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <span>—</span>
    );
  };

  // BENS
  const goodsBodyTemplate = (row: IExportData) => {
    const rows = goodsRows(row.proc_id);
    return rows.length ? (
      <div style={{ maxHeight: 220, overflowY: "auto" }}>
        <table style={miniTableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Data</th>
              <th style={thStyle}>Descrição</th>
              <th style={thStyle}>Parte</th>
              <th style={{ ...thStyle, textAlign: "right" }}>Valor</th>
              <th style={thStyle}>Depositário</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={`${r.date}-${r.desc}-${r.value}`}>
                <td
                  style={{
                    ...tdStyle,
                    whiteSpace: "nowrap",
                    textAlign: "left",
                  }}
                >
                  {r.date}
                </td>
                <td
                  style={{
                    ...tdStyle,
                    whiteSpace: "normal",
                    textAlign: "left",
                  }}
                >
                  {r.desc}
                </td>
                <td
                  style={{
                    ...tdStyle,
                    whiteSpace: "nowrap",
                    textAlign: "left",
                  }}
                >
                  {r.part}
                </td>
                <td
                  style={{
                    ...tdStyle,
                    textAlign: "right",
                    whiteSpace: "nowrap",
                  }}
                >
                  R$
                  {r.value}
                </td>
                <td style={{ ...tdStyle, whiteSpace: "normal" }}>
                  {r.depositary}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <span>—</span>
    );
  };

  const headerGroup = React.useMemo(() => {
    const commonLeft = [
      "Número do processo",
      "Data de Ajuizamento",
      ...(Number(status) !== 0 ? ["Situação", "Data Desfecho"] : []),
      "Pólo ativo",
      "Pólo passivo",
      "Adv. Responsável",
      "Localização",
      "Natureza",
      "Objeto",
      "Posição atual",
      "Provável (maior ou igual 80%)",
      "Possível (maior 50%)",
      "Possível (menor ou igual 50%)",
      "Remota (menor ou igual 20%)",
      "Probabilidade",
      "Valor nominal do processo",
    ];

    return (
      <ColumnGroup>
        <Row>
          {commonLeft.map((h) => (
            <Column key={`h1-${h}`} header={h} rowSpan={2} />
          ))}
          <Column
            header="Detalhes Financeiros"
            colSpan={3}
            alignHeader="center"
          />
        </Row>
        <Row>
          <Column header="Custas Processuais" />
          <Column header="Depósitos Judiciais" />
          <Column header="Bens Penhorados" />
        </Row>
      </ColumnGroup>
    );
  }, [status]);

  return (
    <Container>
      <LoadingOverlay visible={exportando} message="Gerando o arquivo…" />

      <header>
        <div>
          <h3>PABST & HADLICH ADVOGADOS ASSOCIADOS</h3>
          <h5>Relatório Resumido de Informações Processuais - Filtro Excel</h5>
        </div>
      </header>

      <div className="datatable-responsive">
        <div className="card">
          <Tooltip target=".export-buttons>button" position="bottom" />

          <DataTable
            tableClassName="table-lawsuits table"
            id="table-lawsuits"
            ref={dt}
            loading={loading}
            value={exportData}
            editMode="row"
            dataKey="proc_id"
            header={header}
            headerColumnGroup={headerGroup}
            stripedRows
            className="p-datatable-sm"
            paginator
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords}"
            rows={50}
            rowsPerPageOptions={[10, 20, 50, lawsuits.length]}
            paginatorLeft={paginatorLeft}
            paginatorRight={paginatorRight}
            globalFilter={globalFilter}
            emptyMessage="Nenhum registro encontrado."
            responsiveLayout="scroll"
          >
            <Column
              field="proc_reg"
              header="Número do processo"
              alignHeader="center"
              align="left"
              style={{ width: "160px" }}
            />
            <Column
              field="proc_data_ajuiz"
              header="Data de Ajuizamento"
              alignHeader="center"
              align="left"
              style={{ width: "160px" }}
            />
            {Number(status) !== 0 ? (
              <Column
                field="proc_em_acordo"
                header="Situação"
                alignHeader="center"
                body={statusBodyTemplate}
                align="left"
                style={{ width: "160px" }}
              />
            ) : null}
            {Number(status) !== 0 ? (
              <Column
                field="proc_desfecho_data"
                header="Data Desfecho"
                alignHeader="center"
                align="left"
                style={{ width: "160px" }}
              />
            ) : null}
            <Column
              field="proc_autor"
              header="Pólo ativo"
              alignHeader="center"
              align="left"
            />
            <Column
              field="proc_reu"
              header="Pólo passivo"
              alignHeader="center"
              align="left"
            />
            <Column
              field="advogado_nome"
              header="Adv. Responsável"
              alignHeader="center"
              align="left"
            />
            <Column
              field="proc_localizacao"
              header="Localização"
              alignHeader="center"
              align="left"
              style={{ width: "140px" }}
            />
            <Column
              field="acao_descricao"
              header="Natureza"
              alignHeader="center"
              align="left"
              style={{ width: "100px" }}
            />
            <Column
              field="proc_assunto"
              header="Objeto"
              alignHeader="center"
              align="left"
            />
            <Column
              field="proc_situacao"
              header="Posição atual"
              alignHeader="center"
              align="left"
              style={{ width: "250px" }}
            />
            <Column
              field="pedido_vl_provavel"
              header="Provável (maior ou igual 80%)"
              alignHeader="center"
              align="left"
            />
            <Column
              field="pedido_vl_possivel1"
              header="Possível (maior 50%)"
              alignHeader="center"
              align="left"
            />
            <Column
              field="pedido_vl_possivel2"
              header="Possível (menor ou igual 50%)"
              alignHeader="center"
              align="left"
            />
            <Column
              field="calc_poss_remota"
              header="Remota (menor ou igual 20%)"
              alignHeader="center"
              align="left"
            />
            <Column
              field="possib_texto"
              header="Probabilidade"
              alignHeader="center"
              align="left"
            />
            <Column
              field="valor_causa"
              header="Valor nominal do processo"
              alignHeader="center"
              align="left"
            />
            <Column
              header="Custas Processuais"
              body={feesBodyTemplate}
              alignHeader="center"
              bodyStyle={{ padding: 0, verticalAlign: "top" }}
              style={{ width: "420px" }}
              align="center"
            />
            <Column
              header="Depósitos Judiciais"
              body={depositsBodyTemplate}
              alignHeader="center"
              bodyStyle={{ padding: 0, verticalAlign: "top" }}
              style={{ width: "420px" }}
              align="center"
            />
            <Column
              header="Bens Penhorados"
              body={goodsBodyTemplate}
              alignHeader="center"
              bodyStyle={{ padding: 0, verticalAlign: "top" }}
              style={{ width: "560px" }}
              align="center"
            />
          </DataTable>
        </div>
      </div>
    </Container>
  );
};

export default LawsuitSummaryReportExcel;
